import axios, { AxiosError as OptionalAxiosError, AxiosResponse } from 'axios';

const generateTempId = () => {
  return `${Math.floor(Math.random() * Date.now())}`;
};

export const createEmptyDocumentUpload = () => ({
  tempId: generateTempId(),
  file: undefined,
});

// "-?" gets rid of the optionality for the given property.
type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

// In the type guard we make sure that error.response is not undefined, but AxiosError by
// default marks every property as optional so we override response as required to have a more
// accurate type.
type AxiosError<T> = WithRequired<OptionalAxiosError<T>, 'response'>;

/**
 * Generates a Type Guard for the given type T as an Axios error, where T represents the data of the error's response.
 * It does this based on some assertions on the given response object.
 * @param errorResponseValidator checks whether the Axios response comforms to T
 * @returns A function that receives an error and returns a Type Guard for AxiosError<T>
 */
export const buildErrorTypeGuard =
  <T>(errorResponseValidator: (response: AxiosResponse) => boolean) =>
  (error: unknown): error is AxiosError<T> => {
    return axios.isAxiosError(error) && error.response !== undefined && errorResponseValidator(error.response);
  };
